<script setup>
import { channelIcon, channelImage } from '@/constants/channels'

defineProps({
  slug: { type: String, default: '' },
  // Icons are drawn by a font-like class, images fill the badge, so they are sized apart
  iconClass: { type: String, default: 'size-5' },
  imageClass: { type: String, default: 'size-5' },
})
</script>

<template>
  <img
    v-if="channelImage(slug)"
    :src="channelImage(slug)"
    alt=""
    class="object-contain"
    :class="imageClass"
  />
  <span v-else :class="[channelIcon(slug), iconClass]" />
</template>
